module.exports = __webpack_public_path__ + "img/open_in_safari.10ef407e.png";